<template>
  <div class="achievement-info">
    <div class="achievement-box">
      <div :class="['title', , isExpand ? 'btm-border' : '']">
        <div class="topLeftPart">
          <span class="iconfont icon-jiangpai-shi"></span>
          <span>{{
            savePrice ? `我在搜货精选已省${savePrice} 元 ` : "快去购物得返利吧~"
          }}</span>
        </div>
        <span @click="tiggerAchieve"
          >查看成就
          <i
            :class="[
              'iconfont icon-down-trangle-copy',
              isExpand ? 'rotade' : '',
            ]"
          ></i>
        </span>
      </div>
        <template>
          <div class="achievemen-detail" :class="boxIsExpand?'normalHeight':''">
            <div :class="['d-item', isExpand ? 'show' : 'hide']">
              <p class="iconfont icon-wallet"></p>
              <div class="item-msg">
                <p>{{ achieveData.TotalRebatePrice || 0 }} 元</p>
                <p>累计节省金额</p>
              </div>
            </div>
            <div :class="['d-item', isExpand ? 'show' : 'hide']">
              <p class="iconfont icon-ka"></p>
              <div class="item-msg">
                <p>{{ achieveData.TotalFreeCardQty || 0 }} 张</p>
                <p>累计获得免单卡</p>
              </div>
            </div>
            <div :class="['d-item', isExpand ? 'show' : 'hide']">
              <p class="iconfont icon-liwu2"></p>
              <div class="item-msg">
                <p>{{ achieveData.BuyNums || 0 }} 件</p>
                <p>累计获得商品</p>
              </div>
            </div>
            <div :class="['d-item', isExpand ? 'show' : 'hide']">
              <p class="iconfont icon-R2"></p>
              <div class="item-msg">
                <p>{{ achieveData.JoinDays || 0 }} 天</p>
                <p>加入搜货</p>
              </div>
            </div>
            <div :class="['btn', isExpand ? 'show' : 'hide']" @click="shareNow">
              立即分享，获得免单卡
            </div>
          </div>
        </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeadInfo",
  data() {
    return {
      isExpand: false, // 是否展开
      timeOut: null,
      boxIsExpand: false,
    };
  },
  props: {
    achieveData: {
      type: Object,
      require: true,
      default: () => {
        return {};
      },
    },
    // 节省的金额
    savePrice: {
      type: [Number, String],
      default: 0,
    },
  },
  methods: {
    tiggerAchieve() {
      if (this.timeOut) clearTimeout(this.timeOut);
      this.isExpand = !this.isExpand;
      this.timeOut = setTimeout(() => {
        this.boxIsExpand = !this.boxIsExpand;
      }, 100);
      this.$emit("tiggerAchieve", this.isExpand);
    },
    // 立即分享
    shareNow() {
      this.$emit("shareNow");
    },
    close() {
      if (this.timeOut) clearTimeout(this.timeOut);
      this.isExpand = false;
      this.boxIsExpand = false;
    },
  },
};
</script>

<style scoped lang="scss">
.achievement-info .save-tip {
  color: #bcbcbc;
  position: absolute;
  left: 10px;
  top: 32px;
}
.achievement-box {
  position: relative;
  // padding: 0 10px 0;
  box-sizing: border-box;
  width: 100%;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 12px;
  .topLeftPart {
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 16px;
      margin-right: 3px;
    }
  }
}
.achievement-box .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  border-bottom: 1px solid transparent;
  transition: all 0.5s ease-in-out;
  box-sizing: border-box;
  background: #000;
  padding: 0 15px;
  z-index: 1000;
}
.achievement-box .btm-border {
  border-bottom-color: #585045;
}
.achievement-box span {
  display: inline-block;
  cursor: pointer;
}
.achievement-box span:first-child {
  font-size: 14px;
}
.achievement-box span > i {
  vertical-align: middle;
  font-size: 14px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
}
.achievement-box .rotade {
  transform: rotateZ(-180deg);
}
.achievemen-detail {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: #000;
  z-index: 99;
  height: 0;
  transition: 0.3s;
  transition-delay: 0.1s;
  overflow: hidden;
  &.normalHeight {
    transition: 0.3s;
    transition-delay: 0;
    height: 200px;
  }
}
.achievemen-detail .d-item {
  width: 50%;
  margin: 15px 0 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 45px;
}
.achievemen-detail .d-item .iconfont {
  font-size: 28px;
  margin-right: 10px;
  color: #dddddd;
}
.achievemen-detail .d-item .icon-R2 {
  font-size: 26px;
  margin-right: 12px;
}
.achievemen-detail .item-msg p:last-child {
  color: #bcbcbc;
  margin-top: 3px;
}
.achievemen-detail .btn {
  width: 48%;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 5px auto 15px;
  border: 1px solid #ffffff;
  border-radius: 25px;
}
.achievemen-detail .btn:active {
  background: #302f2d;
}
.achievemen-detail .show {
  transition: 0.5s;
  transition-delay: 0.3s;
  opacity: 1;
}
.achievemen-detail .hide {
  transition: 0.5s;  
  opacity: 0;
}
@media screen and (max-width: 320px) {
  .achievemen-detail .d-item {
    padding-left: 0;
  }
}
</style>
